import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';

import FlightSummary from './flightSummary/FlightSummary';
import FlightOptions from './flightOptions/FlightOptions';
import Listener from '../../const/Listener';
import ErrorsCodes from '../../const/ErrorsCodes';
import EventEmitter from '../modules/event-emitter/EventEmitter';
import filterUsecase from '../../usecases/filterUnavailableFlighs/FilterUnavailableFlights';
import _ from 'lodash';

import './FlightSelection.css';
import InfoModal from '../searchBox/infoModal/InfoModal';

const I18n = require('i18n-react').default;

const propTypes = {
  id: PropTypes.string.isRequired,
  origin: PropTypes.string.isRequired,
  finalDestination: PropTypes.string.isRequired,
  originAirportName: PropTypes.string.isRequired,
  finalDestinationAirportName: PropTypes.string.isRequired,
  departureFlightsFiltered: PropTypes.arrayOf(
    PropTypes.shape({
      originAirport: PropTypes.string.isRequired,
      originAirportName: PropTypes.string.isRequired,
      finalDestination: PropTypes.string.isRequired,
      finalDestinationName: PropTypes.string.isRequired,
      departureDate: PropTypes.string,
      departureTime: PropTypes.string.isRequired,
      finalArrivalDate: PropTypes.string,
      finalArrivalTime: PropTypes.string.isRequired,
      dateVariation: PropTypes.number.isRequired,
      elapsedFlightTime: PropTypes.string,
      firstFlightNumber: PropTypes.number.isRequired,
      operatingCarriers: PropTypes.array.isRequired,
      prices: PropTypes.arrayOf(
        PropTypes.shape({
          category: PropTypes.string.isRequired,
          passenger: PropTypes.string,
          value: PropTypes.number,
          currency: PropTypes.string
        })
      ),
      baggage: PropTypes.arrayOf(
        PropTypes.shape({
          category: PropTypes.string.isRequired,
          quantity: PropTypes.number,
          weight: PropTypes.number
        })
      ),
      connection: PropTypes.number.isRequired,
      hasExchangeAirport: PropTypes.bool.isRequired,
      throughFlight: PropTypes.number.isRequired,
      returnFlights: PropTypes.arrayOf(PropTypes.object),
      flightGroup: PropTypes.arrayOf(PropTypes.object)
    })
  ),
  returnFlightsFiltered: PropTypes.arrayOf(
    PropTypes.shape({
      originAirport: PropTypes.string.isRequired,
      originAirportName: PropTypes.string.isRequired,
      finalDestination: PropTypes.string.isRequired,
      finalDestinationName: PropTypes.string.isRequired,
      departureDate: PropTypes.string,
      departureTime: PropTypes.string.isRequired,
      finalArrivalDate: PropTypes.string,
      finalArrivalTime: PropTypes.string.isRequired,
      dateVariation: PropTypes.number.isRequired,
      elapsedFlightTime: PropTypes.string,
      firstFlightNumber: PropTypes.number.isRequired,
      operatingCarriers: PropTypes.array.isRequired,
      prices: PropTypes.arrayOf(
        PropTypes.shape({
          category: PropTypes.string,
          passenger: PropTypes.string,
          value: PropTypes.number,
          currency: PropTypes.string
        })
      ),
      connection: PropTypes.number.isRequired,
      hasExchangeAirport: PropTypes.bool.isRequired,
      throughFlight: PropTypes.number.isRequired,
      returnFlights: PropTypes.arrayOf(PropTypes.object),
      flightGroup: PropTypes.arrayOf(PropTypes.object)
    })
  ),
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string,
  startDateChangeCallback: PropTypes.func.isRequired,
  endDateChangeCallback: PropTypes.func.isRequired,
  callbackAlterSearch: PropTypes.func.isRequired,
  callbackSelectFlights: PropTypes.func.isRequired,
  callbackAlterFlights: PropTypes.func.isRequired,
  filter: PropTypes.shape({
    typeTrip: PropTypes.string
  }),
  toogleElapsedFlightTime: PropTypes.bool,
  toggleDetailsModal: PropTypes.bool,
  isGridLoading: PropTypes.bool,
  cabinCategory: PropTypes.string,
  isCallcenterEnabled: PropTypes.bool,
  numPagination: PropTypes.number,
  callBackShowButtonPaginationReturn: PropTypes.func
};

const defaultProps = {
  toogleElapsedFlightTime: false,
  toggleDetailsModal: false,
  cabinCategory: 'ECONOMY'
};

const ROUND_TRIP = 'roundTrip';

class FlightSelection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      departureFlight: null,
      departureSummaryFlight: null,
      returnFlight: null,
      returnFlightsOriginal: null,
      returnSummaryFlight: null,
      isLoading: this.props.isGridLoading,
      openModal: false,
      messageInfo: null,
      urlRedirect: '/',
      isCallcenterEnabled: false
    };

    this.setDepartureFlight = this.setDepartureFlight.bind(this);
    this.setReturnFlight = this.setReturnFlight.bind(this);
    this.unsetDepartureFlight = this.unsetDepartureFlight.bind(this);
    this.unsetReturnFlight = this.unsetReturnFlight.bind(this);
    this.updateList = this.updateList.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.originalDepartureFlights !== nextProps.originalDepartureFlights ||
      this.props.originalReturnFlights !== nextProps.originalReturnFlights
    ) {
      this.cleanState();
      if(nextProps.numPagination==1)
       window.scrollTo(0, 0);
    }
  }

  componentWillMount() {
    this.setState({
      alterReturnFlightOverviewListener: EventEmitter.createListener(
        Listener.ALTER_RETURN_FLIGHT_OVERVIEW_LISTENER,
        this.unsetReturnFlight
      ),
      alterDepartureFlightOverviewLisetner: EventEmitter.createListener(
        Listener.ALTER_DEPARTURE_FLIGHT_OVERVIEW_LISTENER,
        this.unsetDepartureFlight
      ),
      modalInactivityListener: EventEmitter.createListener(
        Listener.SHOW_MODAL_INACTIVITY,
        this.showModalInactivity
      ),
      filterChangeListener: EventEmitter.createListener(
        Listener.LIST_CHANGE_FILTER,
        this.updateList
      )
    });
  }

  componentWillUnmount() {
    EventEmitter.removeListener(this.state.alterReturnFlightOverviewListener);
    EventEmitter.removeListener(this.state.alterDepartureFlightOverviewLisetner);
    EventEmitter.removeListener(this.state.modalInactivityListener);
    EventEmitter.removeListener(this.state.filterChangeListener);
  }

  showModalInactivity = errorType => {
    if (ErrorsCodes.CALLCENTER_ACCESS_DENIED_ERROR === errorType[0]) {
      this.setState({
        openModal: true,
        urlRedirect: '/?callcenter=false',
        redirectToCallcenter: false,
        messageInfo: I18n.translate('home.msg.error')
      });
    } else {
      this.setState({
        openModal: true,
        redirectToCallcenter: true,
        messageInfo: I18n.translate('home.msg.session.callCenterExpired')
      });
    }
  };

  closeModal = () => {
    if (this.state.redirectToCallcenter) {
      document.location.assign(global.env.CALLCENTER_LOGOUT_URL);
    } else {
      this.setState({
        openModal: false,
        isRedirect: true
      });
    }
  };

  setDepartureFlight(departureFlightChoosen) {
    window.scrollTo(0, 0);
    departureFlightChoosen.flightDate = this.props.startDate;
    this.setState({
      departureFlight: departureFlightChoosen,
      departureSummaryFlight: this.buildSummaryFlight(departureFlightChoosen)
    });

    if (!this.isRoundTrip()) {
      this.props.callbackSelectFlights(departureFlightChoosen);
      this.props.callBackShowButtonPaginationReturn(false);
    } else {
      this.setState(
        {
          isLoading: true
        },
        () => window.scrollTo(0, 0)
      );
      this.loadAvailableReturnFlights(departureFlightChoosen);
    }
  }

  unsetDepartureFlight() {
    window.location.reload();
    this.cleanState();
    EventEmitter.emitEvent(Listener.CLEAR_OVERVIEW_LISTENER);
    this.props.callbackAlterFlights();
  }

  setReturnFlight(returnFlightChoosen) {
    window.scrollTo(0, 0);
    returnFlightChoosen.flightDate = this.props.endDate;
    this.setState({
      returnFlight: returnFlightChoosen,
      returnSummaryFlight: this.buildSummaryFlight(returnFlightChoosen)
    });

    this.props.callbackSelectFlights(this.state.departureFlight, returnFlightChoosen);
  }

  unsetReturnFlight() {
    this.setState({
      returnFlight: null,
      returnSummaryFlight: null
    });
    EventEmitter.emitEvent(Listener.CLEAR_OVERVIEW_LISTENER);
    this.props.callbackAlterFlights();
  }

  cleanState() {
    this.setState({
      departureFlight: null,
      departureSummaryFlight: null,
      returnFlight: null,
      returnSummaryFlight: null,
      returnFlightsOriginal: null
    });
  }

  updateList() {
    this.setState({
      isLoading: true
    });
    this.loadAvailableReturnFlights(this.state.departureFlight);
  }

  buildSummaryFlight(flightChoosen) {
    return {
      value: flightChoosen.value,
      category: flightChoosen.category,
      departureTime: flightChoosen.flight.departureTime,
      arrivalTime: flightChoosen.flight.finalArrivalTime,
      flightNumber: flightChoosen.flight.firstFlightNumber,
      originAirport: flightChoosen.flight.originAirport,
      originAirportName: flightChoosen.flight.originAirportName,
      destinationAirport: flightChoosen.flight.finalDestination,
      destinationAirportName: flightChoosen.flight.finalDestinationName,
      operatingCarriers: flightChoosen.flight.operatingCarriers,
      connections: flightChoosen.flight.connection,
      flightDate: flightChoosen.flight.departureDate,
      throughFlights: flightChoosen.flight.throughFlight,
      hasAirportChange: flightChoosen.flight.hasExchangeAirport,
      plusDays: flightChoosen.flight.dateVariation
    };
  }

  loadAvailableReturnFlights = departureSelected => {
    const returnFlights = this.props.returnFlightsFiltered;
    const departureRecommendationsSelected = departureSelected.flight.recommendations;
    this.props.callBackShowButtonPaginationReturn(false);

    const departureCategoriesSelected = departureRecommendationsSelected.filter(
      recommendation =>
        recommendation.departureCategory === departureSelected.category.toUpperCase()
    );

    const returnFlightsSelected = [];
    departureCategoriesSelected[0].returnFlights.forEach(function(flight) {
      returnFlightsSelected[flight.id] = flight.categories;
    });

    let filteredReturnFlights = returnFlights.filter(flight => {
      return returnFlightsSelected[flight.id];
    });

    const availableReturnFlights = filteredReturnFlights.map(flight => {
      const categories = returnFlightsSelected[flight.id];

      flight.prices = this.getPricesFromRecommendation(categories);
      const economyCategory = this.getCategoryFromRecommendation(categories, 'ECONOMY');
      const businessCategory = this.getCategoryFromRecommendation(categories, 'BUSINESS');
      flight.fee = {
        economy: economyCategory.fee || {},
        business: businessCategory.fee || {}
      };
      flight.fare = {
        economy: economyCategory.fare || {},
        business: businessCategory.fare || {}
      };
      flight.baggageReturn = {
        economy: economyCategory.baggageRule || {},
        business: businessCategory.baggageRule || {}
      };
      flight.points = {
         value : (economyCategory.points && economyCategory.points.value) || (businessCategory.points && businessCategory.points.value)
      }
      flight.ranges = economyCategory ? economyCategory.ranges : businessCategory.ranges;
      return flight;
    });

    this.props.updateFilterReturnFlights();

    filterUsecase.execute(availableReturnFlights).then(flights => {
      if (this.state.returnFlightsOriginal === null) {
        this.setState({
          returnFlightsOriginal: flights
        });
      }
      this.setState({
        filteredReturnFlights: flights,
        isLoading: false
      });
    });
  };

  getCategoryFromRecommendation(categories, type) {
    return (
      categories.filter(category => {
        return category.returnCategory === type;
      })[0] || {}
    );
  }

  getPricesFromRecommendation(categories) {
    return _.flatMap(categories, category => {
      let returnCategory = category.returnCategory;
      return _.map(category.prices, price => {
        price.category = returnCategory;
        return price;
      });
    });
  }

  isRoundTrip() {
    return this.props.filter.typeTrip === ROUND_TRIP;
  }

  renderDepartureFlightSummary() {
    if (this.state.departureFlight) {
      return (
        <div className="flightSummary flightSummary--departure">
          <Row>
            <Col md={12}>
              <FlightSummary
                id="departureFlightSummary"
                isDeparture={true}
                toogleElapsedFlightTime={this.props.toogleElapsedFlightTime}
                {...this.state.departureFlight}
                onChangeFlightClicked={this.unsetDepartureFlight}
                ref={e => (this.departureFlightSummary = e)}
              />
            </Col>
          </Row>
        </div>
      );
    }
    return null;
  }

  renderReturnFlightSummary() {
    if (this.state.returnFlight) {
      return (
        <div className="flightSummary flightSummary--return">
          <div className="breakLine" />
          <Row>
            <Col md={12}>
              <FlightSummary
                id="returnFlightSummary"
                isDeparture={false}
                toogleElapsedFlightTime={this.props.toogleElapsedFlightTime}
                {...this.state.returnFlight}
                onChangeFlightClicked={this.unsetReturnFlight}
                ref={e => (this.returnFlightSummary = e)}
              />
            </Col>
          </Row>
        </div>
      );
    }
    return null;
  }

  renderDepartureFlightOptions() {
    if (!this.state.departureFlight) {
      return (
        <Row>
          <Col md={12}>
            <FlightOptions
              id="departureFlightOptions"
              isDeparture={true}
              origin={this.props.origin}
              finalDestination={this.props.finalDestination}
              originAirportName={this.props.originAirportName}
              finalDestinationAirportName={this.props.finalDestinationAirportName}
              flights={this.props.departureFlightsFiltered}
              date={this.props.startDate}
              onClick={this.props.startDateChangeCallback}
              callback={this.setDepartureFlight}
              callbackAlterSearch={this.props.callbackAlterSearch}
              filterDepartureDate={this.props.startDate}
              filterReturnDate={this.props.endDate}
              isLoading={this.props.isGridLoading}
              toogleElapsedFlightTime={this.props.toogleElapsedFlightTime}
              toggleDetailsModal={this.props.toggleDetailsModal}
              filterCabinCategory={this.props.cabinCategory}
              ref={e => (this.departureFlightOptions = e)}
              filteredList={this.props.filteredList}
              updateFilters={this.props.updateFilters}
              auxFlights={this.props.originalDepartureFlights}
              clearFilters={this.props.clearFilters}
              flightType={0}
              isCallcenterEnabled={this.props.isCallcenterEnabled}
              numPagination={this.props.numPagination}
            />
          </Col>
        </Row>
      );
    }
    return null;
  }

  renderReturnFlightOptions() {
    if (this.state.departureFlight && !this.state.returnFlight && this.isRoundTrip()) {
      return (
        <Row>
          <Col md={12}>
            <FlightOptions
              id="returnFlightOptions"
              isDeparture={false}
              origin={this.props.finalDestination}
              finalDestination={this.props.origin}
              originAirportName={this.props.finalDestinationAirportName}
              finalDestinationAirportName={this.props.originAirportName}
              flights={this.state.filteredReturnFlights}
              date={this.props.endDate}
              onClick={this.props.endDateChangeCallback}
              callback={this.setReturnFlight}
              callbackAlterSearch={this.props.callbackAlterSearch}
              filterDepartureDate={this.props.startDate}
              filterReturnDate={this.props.endDate}
              isLoading={this.props.isGridLoading || this.state.isLoading}
              toogleElapsedFlightTime={this.props.toogleElapsedFlightTime}
              toggleDetailsModal={this.props.toggleDetailsModal}
              manyDepartureFlightOptions={this.props.originalDepartureFlights.length > 1}
              filterCabinCategory={this.props.cabinCategory}
              ref={e => (this.returnFlightOptions = e)}
              filteredList={this.props.filteredList}
              updateFilters={this.props.updateFilters}
              auxFlights={this.state.returnFlightsOriginal}
              clearFilters={this.props.clearFilters}
              flightType={1}
              isCallcenterEnabled={this.props.isCallcenterEnabled}
            />
          </Col>
        </Row>
      );
    }
    return null;
  }

  render() {
    return (
      <div>
        {this.renderDepartureFlightSummary()}
        {this.renderReturnFlightSummary()}
        {this.renderDepartureFlightOptions()}
        {this.renderReturnFlightOptions()}
        <InfoModal
          id="modalInfo"
          message={this.state.messageInfo}
          showModal={this.state.openModal}
          close={this.closeModal}
          ref={c => {
            this.modalInfo = c;
          }}
        />
        {this.state.isRedirect ? (
          <Redirect
            push
            to={{
              pathname: this.state.urlRedirect
            }}
          />
        ) : null}
      </div>
    );
  }
}

FlightSelection.propTypes = propTypes;
FlightSelection.defaultProps = defaultProps;
export default FlightSelection;



// WEBPACK FOOTER //
// ./src/components/flightSelection/FlightSelection.jsx